"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useOrder = require("@/hooks/use-order");
var _ChangeLogistics = _interopRequireDefault(require("@/components/ChangeLogistics"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'sendFrom',
  components: {
    ChangeLogistics: _ChangeLogistics.default
  },
  data: function data() {
    return {
      express: []
    };
  },
  props: {
    formItem: {
      type: Object,
      default: null
    },
    isShowBtn: {
      type: Boolean,
      default: false
    }
  }
};